import type { Track } from '@core/plugins/analytics/track'
import { aggregateProperties, analytics } from '@core/analytics/core-events/lib'
import { Clickout, Open, View } from '@core/analytics/actions'
import { Comparison } from './objects/Comparison'
import { ComparisonSection } from './objects/ComparisonSection'
import { ComparisonResult } from './objects/ComparisonResult'
import { ComparisonPanel, type ComparisonPanelType } from './objects/ComparisonPanel'
import { Corridor as CorridorObj } from '@core/analytics/objects/Corridor'
import type { Corridor } from '@core/types/imt'
import { IMTSummary } from './objects/IMTSummary'

export async function imtSummaryView(
  track: Track,
  summary: IMTSummary | undefined,
  section: ComparisonSection | undefined,
) {
  if (!summary) return
  return track(analytics(new View(), aggregateProperties(summary, section)))
}

export async function comparisonView(
  track: Track,
  comparison: Comparison | undefined,
  section: ComparisonSection | undefined,
) {
  if (!comparison) return
  return track(analytics(new View(), aggregateProperties(comparison, section)))
}

export async function comparisonResultClickout(
  track: Track,
  comparison: Comparison | undefined,
  section: ComparisonSection | undefined,
  result: ComparisonResult | undefined,
) {
  if (!result) return
  return track(analytics(new Clickout(), aggregateProperties(result, section, comparison)))
}

export async function panelOpen(
  track: Track,
  type: ComparisonPanelType,
  comparison: Comparison | undefined,
  section: ComparisonSection | undefined,
  result: ComparisonResult | undefined,
) {
  return track(
    analytics(
      new Open(),
      aggregateProperties(new ComparisonPanel(type), result, section, comparison),
    ),
  )
}

export async function noResultsWarning(
  track: Track,
  corridor: Corridor,
  amountUsd?: number,
  alternativeToNoResults?: string,
) {
  const obj = CorridorObj.getInstance({ ...corridor, amountUsd, alternativeToNoResults })
  return track(analytics(new View(), { ...obj, name: 'IMT No Results Warning' }))
}
